import { createApp } from 'vue';
import { createPinia } from 'pinia';
import router from '@/router/index';
import '@/router/router-hook';
import { useErrorLog } from "@/hooks/use-error-log"

import App from './App.vue';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import 'bootstrap';
import '@/styles/style.css';
import Vue3Toastify from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

const pinia = createPinia();

const app = createApp(App);

app.config.globalProperties.$filters = {
	formatDate(value) {
		if (value) {
			return (new Date(value*1000)).toLocaleDateString('ru-RU');
		}
		return null;
	},
	formatDateTime(value) {
		if (value) {
			return (new Date(value*1000)).toLocaleString('ru-RU', {
  				year: 'numeric', month: 'numeric', day: 'numeric',
  				hour: 'numeric', minute: 'numeric',
				hour12: false
			});
		}
		return null;
	},
	formatNumber(value) {
		// http://numeraljs.com/
		if (value) {
			return numeral(value).format('0 0.00');
		}
		return null;
	},
	formatMoney(value) {
		if (value) {
			return numeral(value).format('0 0.00') + ' руб';
		}
		return null;
	}
};

// Add a custom error handler, useful for logging errors
// somewhere or handling errors more elegantly. eg show a
// whole page error screen if something goes wrong.
app.config.errorHandler = (err) => {
	useErrorLog(err);
};
  
// Custom warning handler (only runs in development)
//app.config.warnHandler = (warn) => {
//	useWarningLog(warn);
//};

app.use(pinia);
app.use(router);
app.use(Vue3Toastify, {
	autoClose: 5000,
  }
);
app.mount('#app');